var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMagnifyingGlass = function SvgMagnifyingGlass(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 11.4C3.7938 11.4 1.6 9.20619 1.6 6.5C1.6 3.7938 3.7938 1.6 6.5 1.6C9.20619 1.6 11.4 3.7938 11.4 6.5C11.4 9.20619 9.20619 11.4 6.5 11.4ZM1 6.5C1 3.46243 3.46243 1 6.5 1C9.53757 1 12 3.46243 12 6.5C12 7.62264 11.6636 8.66672 11.0862 9.53696L18.6496 17.1004C19.0774 17.5282 19.0774 18.2218 18.6496 18.6496C18.2218 19.0774 17.5282 19.0774 17.1004 18.6496L9.53696 11.0862C8.66672 11.6636 7.62264 12 6.5 12C3.46243 12 1 9.53757 1 6.5ZM10.023 10.7237L17.5246 18.2254C17.7181 18.4189 18.0319 18.4189 18.2254 18.2254C18.4189 18.0319 18.4189 17.7181 18.2254 17.5246L10.7237 10.023C10.5116 10.277 10.277 10.5116 10.023 10.7237Z",
    fill: "currentColor"
  })));
};
export default SvgMagnifyingGlass;